import { render, staticRenderFns } from "./CardCompanyAdmin.vue?vue&type=template&id=5e7ead44&scoped=true"
import script from "./CardCompanyAdmin.vue?vue&type=script&lang=js"
export * from "./CardCompanyAdmin.vue?vue&type=script&lang=js"
import style0 from "./CardCompanyAdmin.vue?vue&type=style&index=0&id=5e7ead44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ead44",
  null
  
)

export default component.exports